import { Link } from "react-router-dom";
import { Globe, Mail, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer 
      className="bg-[#0F172A] text-white py-16 md:py-20"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <Globe className="w-8 h-8 text-[#E15636]" />
              <span className="font-heading text-2xl">VisaFlows</span>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed">
              Your trusted source for visa information and guidance. 
              Making international travel accessible.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading text-lg mb-4">Services</h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/visa-finder" 
                  className="text-slate-400 text-sm hover:text-white transition-colors"
                >
                  Visa Finder
                </Link>
              </li>
              <li>
                <Link 
                  to="/evisa" 
                  className="text-slate-400 text-sm hover:text-white transition-colors"
                >
                  eVisa Services
                </Link>
              </li>
              <li>
                <Link 
                  to="/oci" 
                  className="text-slate-400 text-sm hover:text-white transition-colors"
                >
                  OCI Card (India)
                </Link>
              </li>
              <li>
                <Link 
                  to="/pcc" 
                  className="text-slate-400 text-sm hover:text-white transition-colors"
                >
                  Police Clearance
                </Link>
              </li>
              <li>
                <Link 
                  to="/terms" 
                  className="text-slate-400 text-sm hover:text-white transition-colors"
                >
                  Terms & Conditions
                </Link>
              </li>
            </ul>
          </div>

          {/* Popular Destinations */}
          <div>
            <h4 className="font-heading text-lg mb-4">Popular Destinations</h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/visa/US" 
                  className="text-slate-400 text-sm hover:text-white transition-colors"
                >
                  United States
                </Link>
              </li>
              <li>
                <Link 
                  to="/visa/GB" 
                  className="text-slate-400 text-sm hover:text-white transition-colors"
                >
                  United Kingdom
                </Link>
              </li>
              <li>
                <Link 
                  to="/visa/CA" 
                  className="text-slate-400 text-sm hover:text-white transition-colors"
                >
                  Canada
                </Link>
              </li>
              <li>
                <Link 
                  to="/visa/AU" 
                  className="text-slate-400 text-sm hover:text-white transition-colors"
                >
                  Australia
                </Link>
              </li>
              <li>
                <Link 
                  to="/visa/IN" 
                  className="text-slate-400 text-sm hover:text-white transition-colors"
                >
                  India
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2 text-slate-400 text-sm">
                <Mail className="w-4 h-4 text-[#E15636]" />
                info@visaflows.ca
              </li>
              <li className="flex items-center gap-2 text-slate-400 text-sm">
                <MapPin className="w-4 h-4 text-[#E15636]" />
                Global Service
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm">
              © {new Date().getFullYear()} VisaFlows.ca All rights reserved.
            </p>
            <p className="text-slate-500 text-xs text-center md:text-right">
              Information provided is for educational purposes only. 
              Always verify with official sources.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
